import {FC} from "react";
import styled from "@emotion/styled";
import {HEADER_HEIGHT, MOBILE_HEADER_HEIGHT} from "data/constants/header";
import {useViewController} from "data/services/locator";
import {type ILocalizationController} from "views/controllers/localization/localization.controller";
import {Bindings} from "data/constants/bindings";
import {PureButton} from "views/components/style";
import {media} from "assets/css/media";

const Wrapper = styled.div`
	position: sticky;
	padding: 8px 20px;
	width: 100%;
	background: #224cd8;
	font-size: 12px;
	text-align: center;
	top: ${MOBILE_HEADER_HEIGHT}px;
	left: 0;
	z-index: 49;

	@media (min-width: ${media.tablet}) {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 4px;
		height: 48px;
		top: ${HEADER_HEIGHT}px;
		font-size: 14px;
	}
`;

const Button = styled(PureButton)`
	font-weight: 600;
	text-decoration: underline;
	color: #ffffff;
`;

interface ILoginBanner {
	SSOLogin: () => void;
}

export const LoginBanner: FC<ILoginBanner> = ({SSOLogin}) => {
	const {i18n} = useViewController<ILocalizationController>(Bindings.LocalizationController);

	return (
		<Wrapper>
			<div>{i18n.t("header.login_alert.text")}</div>
			<Button onClick={SSOLogin}>{i18n.t("header.login_alert.button")}</Button>
		</Wrapper>
	);
};
